import { Section } from "Components/Section";
import React from "react";
import { serverConstants } from "Shared/Constants";
import { LcpAppPageWrapper } from "./LcpWorkflowPageWrapper";

export function ApplicationRequiresReviewPage() {
  return (
    <LcpAppPageWrapper isWide documentTitle={"Application Requires Review"}>
      <Section
        title={`${serverConstants.InsuranceName} Application Under Review`}
      >
        Given the application answers entered, we are unable to automatically
        quote your policy online. Your application for{" "}
        {serverConstants.InsuranceName} is currently under review. Your request
        has been submitted to our team and we will contact you regarding the
        status of your application.
        <nav style={{ textAlign: "center", marginTop: "1em" }}>
          <a href={serverConstants.StaticSiteUrl}>
            Return to {serverConstants.StaticSiteHost}
          </a>
        </nav>
      </Section>
    </LcpAppPageWrapper>
  );
}
